import { formatDuration } from '../../../../utils/dateUtils';

export function getTotalGroupedItems<T>(
  groupedData: Record<string, T[]>,
): number {
  return Object.values(groupedData).reduce((sum, arr) => sum + arr.length, 0);
}

export function getTotalMeetingDuration(
  meetings: Record<string, Array<{ duration: number }>>,
): string {
  const totalMins = Object.values(meetings).reduce(
    (total, dayMeetings) =>
      total +
      dayMeetings.reduce((dayTotal, meeting) => dayTotal + meeting.duration, 0),
    0,
  );

  if (totalMins === 0) return '';
  return ` (${formatDuration(totalMins)})`;
}
